import * as styles from './BookCall.view.css';

// Renders the HubSpot meeting as a direct iframe on the prefilled meeting URL
// (`?embed=true` appended by buildEmbedUrl). HubSpot's loader script
// (static.hsappstatic.net/MeetingsEmbedCode/...) only injects this exact
// iframe — and the script URL serves 403 from HubSpot's CDN, which left the
// booking step blank. The booked meeting auto-logs on the contact matched by
// the prefilled email, and the meetings page posts the booked window message
// to the parent itself, so nothing else depended on the loader.
export const HubspotMeetingsEmbed = ({ embedUrl }: { embedUrl: string }) => (
  <div className={styles.embedWrapper}>
    <iframe
      src={embedUrl}
      title="Book your onboarding call"
      className={styles.embedIframe}
    />
  </div>
);
